<template>
  <div class="page" :style="{'padding-top': safeArea.top + 'px'}">
    <div class="page-nav">
      <slot name="nav">
      </slot>
    </div>
    <div v-if="hasHead" class="page-head" :style="{'padding-top': safeArea.top + 'px'}">
      <div v-if="title" class="page-head-default">
        <img class="left" src="../../assets/imgs/back.png" alt="" @click="onBack">
        {{title}}
        <img class="right" src="../../assets/imgs/logo.png" alt="">
      </div>
      <slot name="head">
      </slot>
    </div>
    <div class="page-body">
      <slot></slot>
    </div>
    <div class="page-foot" v-if="hasFoot">
      <slot name="foot"></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['safeArea']),
    hasHead () {
      return this.$slots.head || this.title
    },
    hasFoot () {
      return this.$slots.foot
    }
  },
  methods: {
    onBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less">
.page{
  height: calc(100vh - 80px);
  &-head{
    background: #000;
    position: fixed;
    z-index: 99;
    top: 0;
    width: 100%;
    font-size: 36px;
    &-default {
      height: 88px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #FD6B11;
      img {
        height: 60px;
        width: 60px;
        left: 32px;
      }
      .left {
        margin-left: 30px;
      }
      .right {
        width: 100px;
        height: 100px;
        margin-right: 30px;
      }
    }
  }
  &-head+&-body{
    padding-top: 88px;
  }
  &-body{
    height: calc(100vh - 168px);
  }
  &-foot{
    background: #FFFFFF;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  &-nav{
    background: #000;
    font-size: 36px;
  }
}
</style>
